import type { SimAvailabilityData } from "app/pages/Customer/Activation/slice/types";
import { getDeviceIncludedPlanResolution } from "../../FixedPhoneFlow/utils/activation-plan-helpers";
import type { DeviceIncludedPlanResolution } from "../../FixedPhoneFlow/utils/activation-plan-helpers";

export function planSummaryLineFromResolution(
  includedPlanResolution: DeviceIncludedPlanResolution
): string | null {
  switch (includedPlanResolution) {
    case "monthly":
      return "Plan - Unlimited Monthly";
    case "yearly":
      return "Plan - Unlimited Yearly";
    case "both":
      return "Plan - Unlimited Monthly & Yearly";
    case "neither":
      return "Plan - Not configured for this device";
    default:
      return null;
  }
}

/**
 * Rows for the activation-code (fixed phone base / IMEI card) verification success dialog.
 */
export function buildActivationCodeCongratulationsRows(
  data?: SimAvailabilityData
): string[] {
  const deviceData: any = data?.device || data;
  if (!deviceData) return [];

  const includedPlanResolution = getDeviceIncludedPlanResolution(deviceData);
  const planSummaryLine = planSummaryLineFromResolution(includedPlanResolution);

  return [
    deviceData.vanityName ? `Device Model - ${deviceData.vanityName}` : null,
    deviceData.imei ? `IMEI Number - ${deviceData.imei}` : null,
    deviceData.iccid ? `Sim - ${deviceData.iccid}` : null,
    deviceData.condition ? `Condition - ${deviceData.condition}` : null,
    `WiFi Compatible - ${deviceData.isWifiCompatible ? "Yes" : "No"}`,
    planSummaryLine,
  ].filter(Boolean) as string[];
}

export function getActivationCodeIncludedPlanResolution(
  data?: SimAvailabilityData
) {
  const deviceData: any = data?.device || data;
  if (!deviceData) return "unknown" as const;
  return getDeviceIncludedPlanResolution(deviceData);
}
